<template>
  <div>
    <validation-provider
      v-slot="{ errors }"
      name="ความถี่"
      rules="required">
      <v-radio-group
        v-model="field"
        class="ml-6"
        :readonly="!editable"
        :error-messages="errors[0]"
        @change="bindValue">
        <div
          v-for="(radioGroup, groupIndex) in data"
          :key="groupIndex"
          class="mt-4">
          <b class="mb-2">{{ radioGroup.title }}</b>
          <v-radio
            v-for="(radio, radioIndex) in radioGroup.list"
            :key="radioIndex"
            class="ml-2 mt-2 radio-list"
            :value="radio.value">
            <template
              v-slot:label
              class="row-label">
              <div class="label-radio">
                {{ radio.text }}
              </div>
              <div
                v-if="!!radio.append"
                class="mx-2 text-center d-flex">
                <div
                  v-for="(col, colIndex) in radio.append"
                  :key="colIndex">
                  <v-text-field
                    v-if="col.fieldType === 'input' && col.type === 'number'"
                    :value="initValue(radio.value, colIndex)"
                    :disabled="radio.value !== field"
                    prepend-icon="mdi-pencil"
                    :readonly="!editable"
                    :type="col.type"
                    min="0"
                    class="extend-field pt-3"
                    :style="col.appendText ? 'width: 217px': ''"
                    @input="setProperty({ field: radio.value,index: colIndex}, $event)">
                    <template
                      v-if="col.appendText"
                      v-slot:append>
                      {{ col.appendText }}
                    </template>
                  </v-text-field>
                  <date-field
                    v-else-if="col.fieldType === 'input' && col.type === 'date'"
                    :value="initValue(radio.value, colIndex)"
                    :disabled="radio.value !== field"
                    label="วันที่"
                    :editable="editable"
                    class="extend-field"
                    @input="setProperty({ field: radio.value,index: colIndex}, $event)" />
                  <time-field
                    v-else-if="col.fieldType === 'input' && col.type === 'time'"
                    :value="initValue(radio.value, colIndex)"
                    :disabled="radio.value !== field"
                    label="เวลา"
                    :editable="editable"
                    @input="setProperty({ field: radio.value, index: colIndex}, $event)" />
                  <v-select
                    v-else-if="col.fieldType === 'input' && col.type === 'day'"
                    :readonly="!editable"
                    :value="initValue(radio.value, colIndex)"
                    :disabled="radio.value !== field"
                    :items="days"
                    prepend-icon="mdi-calendar-range"
                    item-text="text"
                    item-value="value"
                    label="เลือกวัน"
                    small-chips
                    multiple
                    deletable-chips
                    class="extend-field day-selector pt-3"
                    @input="setProperty({ field: radio.value,index: colIndex}, $event)" />
                  <v-select
                    v-else-if="col.fieldType === 'input' && col.type === 'special'"
                    :readonly="!editable"
                    :value="initValue(radio.value, colIndex)"
                    :disabled="radio.value !== field"
                    :items="specialField"
                    prepend-icon="mdi-playlist-star"
                    item-text="text"
                    item-value="value"
                    label="เลือก"
                    class="extend-field day-selector pt-3"
                    @input="setProperty({ field: radio.value,index: colIndex}, $event)" />
                  <div
                    v-else-if="col.fieldType === 'text'"
                    class="pt-5 extend-field">
                    {{ col.text }}
                  </div>
                </div>
              </div>
            </template>
          </v-radio>
        </div>
      </v-radio-group>
    </validation-provider>
  </div>
</template>

<script>
import DateField from './DateField.vue'
import TimeField from './TimeField.vue'

export default {
  components: {
    DateField,
    TimeField
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    oldValue: {
      type: Object,
      default: () => {}
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      days: [
        { text: 'วันจันทร์', value: 'mon' },
        { text: 'วันอังคาร', value: 'tue' },
        { text: 'วันพุธ', value: 'wed' },
        { text: 'วันพฤหัสบดี', value: 'thu' },
        { text: 'วันศุกร์', value: 'fri' },
        { text: 'วันเสาร์', value: 'sat' },
        { text: 'วันอาทิตย์', value: 'sun' }
      ],
      specialField: [
        { text: 'สิ้นเดือน', value: 'lastDayOfMonth' }
      ],
      onlydates: [],
      input: {},
      field: ''
    }
  },
  watch: {
    oldValue: {
      handler () {
        this.initForm()
      },
      deep: true
    }
  },
  created () {
    this.initForm()
  },
  methods: {
    initValue (field, index) {
      return this.input[field] && this.input[field][index] ? this.input[field][index] : null
    },
    initForm () {
      if (this.oldValue) {
        this.field = this.oldValue.field
        if (!this.input[this.field]) {
          this.input[this.field] = this.oldValue.more || []
        }

        this.bindValue()
      }
    },
    bindValue () {
      this.$emit('input', this.field, this.input[this.field])
    },
    setProperty (pointer, val) {
      if (!this.input[pointer.field]) {
        this.input[pointer.field] = []
      }
      this.input[pointer.field][pointer.index] = val

      this.bindValue()
    }
  }
}
</script>

<style>
.row-label {
  /* height: 35px; */
  display: flex;
  flex-direction: row;
}

.extend-field {
  height: 60px;
  padding: 0 8px;

}

.extend-field input {
  text-align: center ;
}

.label-radio {
  width: 210px;
}

.day-selector input {
  width: 140px;
}

.radio-list {
  height: 60px;
}

</style>
